<template>
  <span style="display: none" aria-hidden="true" />
</template>

<script lang="ts">
import {
  clearSocketMobileScanResultHandler,
  closeSocketMobileCapture,
  openSocketMobileCapture,
  setSocketMobileScanResultHandler,
} from '@/utils/socketMobile'
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'

export type ScanResultHandler = (scannedText: string) => void

@Options({})
export default class ScanComponent extends Vue {
  @PropSync('loading', { type: Boolean }) _loading!: boolean
  @Prop({ type: Function, required: true }) readonly onScan!: ScanResultHandler

  async mounted() {
    setSocketMobileScanResultHandler(this.handleScanResult)
    try {
      await openSocketMobileCapture()
    } catch (error) {
      console.error('Socket Mobile capture is unavailable:', error)
    }
  }

  async unmounted() {
    await closeSocketMobileCapture()
    clearSocketMobileScanResultHandler(this.handleScanResult)
  }

  handleScanResult = (scannedText: string) => {
    this.onScan(scannedText)
  }
}
</script>
